import { gql } from "@apollo/client";

export const UPSERT_PARTNER_ADMIN_ACCOUNT = gql`
  mutation ($input: PartnerAccountInput!) {
    upsertPartnerAccount(input: $input) {
      success
      message
    }
  }
`;
